import React, { PropsWithChildren } from 'react';

import {
  PageHeader,
  PageHeaderActions,
  PageHeaderDetails,
  PageHeaderHeading,
} from '@twilio-paste/core/page-header';

import { Layout } from '../Layout';

interface PageComponentProps extends PropsWithChildren {
  pageTitle: string;
  actions?: React.ReactNode;
}

export function PageComponent({ pageTitle, children, actions }: PageComponentProps) {
  return (
    <Layout>
      <PageHeader size="default">
        <PageHeaderDetails>
          <PageHeaderHeading>{pageTitle}</PageHeaderHeading>
          {actions && <PageHeaderActions>{actions}</PageHeaderActions>}
        </PageHeaderDetails>
      </PageHeader>
      {children}
    </Layout>
  );
}
